import React from 'react';
import { Flex } from '../Flex';
import { CloseOutlined } from '../Icon';
import { SVGContainer, IndicatorCircle, ProgressCircle } from './components';
export var AnimatedCloseIcon = function AnimatedCloseIcon(_ref) {
  var onClick = _ref.onClick,
      dismissIn = _ref.dismissIn;
  return /*#__PURE__*/React.createElement(Flex, {
    position: "relative",
    "data-test": "toast-close",
    cursor: "pointer",
    flexShrink: 0,
    alignItems: "center",
    justifyContent: "center",
    onClick: onClick,
    size: 24
  }, /*#__PURE__*/React.createElement(SVGContainer, {
    width: "24",
    height: "24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement(IndicatorCircle, {
    r: "9",
    cx: "12",
    cy: "12"
  }), /*#__PURE__*/React.createElement(ProgressCircle, {
    dismissIn: dismissIn,
    r: "9",
    cx: "12",
    cy: "12"
  })), /*#__PURE__*/React.createElement(CloseOutlined, {
    size: 12
  }));
};